import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { type GetHourlyTuitionBillingResponse } from '~entities/payment/api/hourly-tuition/get-hourly-tuition-billing';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface CreateHourlyTuitionBilling {
  name: string;
  ranges: Array<Range>;
}

export interface Range {
  minMinute: number;
  maxMinute: number;
  flatRate: number;
}

export const createHourlyTuitionBilling = async (
  params: CreateHourlyTuitionBilling,
) => {
  const response = await baseAPI.post<GetHourlyTuitionBillingResponse>(
    'hourly-tuition-billing',
    {
      ...params,
    },
  );
  return response.data;
};

export const useCreateHourlyTuitionBilling = () => {
  return useMutation({
    mutationFn: (params: CreateHourlyTuitionBilling) =>
      createHourlyTuitionBilling(params),

    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.HOURLY_TUITION_BILLING],
      });
    },
  });
};
